module.exports = __webpack_public_path__ + "img/downarrow.389c3b01.svg";